import React, { useState, useEffect, useRef } from "react";
import Moment from "moment";
import { connect } from "react-redux";
import { SuperInfoPause } from "../actions/websocket";
import { showmodalPause } from "../actions";
const { connection_platform } = require("../services/api");

const TimeCounterDashVirtual = ({
  horario, // Pode ser Número (segundos) ou String/Date (Data de Início)
  status,
  max,
  iduser,
  maxTime,
  showmodalpause,
}) => {
  const [, setTick] = useState(0);

  const startTimeRef = useRef(null);

  const intervalRef = useRef(null);

  useEffect(() => {
    if (!startTimeRef.current) {
      if (!isNaN(horario) && typeof horario !== "object") {
        startTimeRef.current = Date.now() - horario * 1000;
      } else {
        startTimeRef.current = new Date(horario).getTime();
      }
    }
  }, [horario]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTick((t) => t + 1);
    }, connection_platform.milliseconds || 1000);

    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (!startTimeRef.current) return;

    const currentElapsed = Date.now() - startTimeRef.current;
    const currentSeconds = Math.round(currentElapsed / 1000);

    if (max > 0 && status === "Pausado" && currentSeconds === max) {
      showmodalpause(true);
      SuperInfoPause(iduser);
    }
  }, [max, status, iduser, showmodalpause]);

  // --- RENDERIZAÇÃO ---
  if (!startTimeRef.current) return <span>--:--:--</span>;

  const diff = Date.now() - startTimeRef.current;
  // Corrigir cor do texto
  const isExceeded = maxTime > 0 && diff > maxTime * 1000;
  const finalColor = isExceeded ? "#c90000" : "inherit";

  // Formata o tempo para exibição
  const formattedTime = Moment.utc(diff).format("HH:mm:ss");

  return (
    <span style={{ color: finalColor, fontSize: "inherit" }}>
      {formattedTime}
    </span>
  );
};

const mapDispatchToProps = (dispatch) => ({
  showmodalpause: (params) => dispatch(showmodalPause(params)),
});

export default connect(null, mapDispatchToProps)(TimeCounterDashVirtual);
